module.exports = __webpack_public_path__ + "static/buenasNoches-f2894042170f0781bc18f40a3a02ade7.png";